import { ActionReducerMap } from '@ngrx/store';
import { TLibraryState } from './library/library.models';
import { libraryReducer } from './library/library.reducer';
import { TMastersState } from './masters/masters.models';
import { mastersReducer } from './masters/masters.reducer';
import { TNavigationState } from './navigation/navigation.models';
import { navigationReducer } from './navigation/navigation.reducer';

export type TEngineeri8AppState = {
  navigationInfo: TNavigationState;
  mastersInfo: TMastersState;
  libraryInfo: TLibraryState;
};

export const Engineeri8AppStateReducer: ActionReducerMap<TEngineeri8AppState, never> = {
  navigationInfo: navigationReducer,
  mastersInfo: mastersReducer,
  libraryInfo: libraryReducer,
};
